var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 12H5C3.34315 12 2 13.3431 2 15V83C2 84.6569 3.34314 86 5 86H73C74.6569 86 76 84.6569 76 83V29.5",
    stroke: "var(--icon-color)",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1924 39.7696L67.4766 11.4853L76.669 20.6777L48.3847 48.9619L39.1924 39.7696Z",
    stroke: "var(--icon-color)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3051 8.65685L75.9619 3L85.1543 12.1924L79.4974 17.8492L70.3051 8.65685Z",
    stroke: "var(--icon-color)",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8492 51.0833L37.071 43.3051L34.5962 53.5581L44.8492 51.0833Z",
    stroke: "var(--icon-color)",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bc6d17bdfb2b53a2319f53420831b285.svg";
export { ForwardRef as ReactComponent };